import type { PropsWithChildren } from "react";
import { createContext } from "react";
import type { WorkflowTemplateActivity, WorkflowTemplateVersionDetails } from "../../../../api/types/workflowTypes";

export interface Props {
  hasEditPermissions: boolean;
  workflowTemplate: WorkflowTemplateVersionDetails;
  onActivityUpdated: (activity: WorkflowTemplateActivity) => void;
}

const WorkflowTemplateDetailsContext = createContext<Props | undefined>(undefined);

export const WorkflowTemplateDetailsContextProvider = ({ children, ...props }: PropsWithChildren<Props>) => (
  <WorkflowTemplateDetailsContext value={props}>{children}</WorkflowTemplateDetailsContext>
);

export default WorkflowTemplateDetailsContext;
